import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PriceRangeFilter = ({ minPrice, maxPrice, onPriceChange }) => {
  const [localMinPrice, setLocalMinPrice] = useState(minPrice || '');
  const [localMaxPrice, setLocalMaxPrice] = useState(maxPrice || '');

  const quickPriceRanges = [
    { label: '< 50 000 FCFA', min: 0, max: 50000 },
    { label: '50 000 - 200 000 FCFA', min: 50000, max: 200000 },
    { label: '200 000 - 500 000 FCFA', min: 200000, max: 500000 },
    { label: '500 000 - 1 000 000 FCFA', min: 500000, max: 1000000 },
    { label: '1 000 000 - 5 000 000 FCFA', min: 1000000, max: 5000000 },
    { label: '> 5 000 000 FCFA', min: 5000000, max: null }
  ];

  useEffect(() => {
    setLocalMinPrice(minPrice || '');
    setLocalMaxPrice(maxPrice || '');
  }, [minPrice, maxPrice]);

  const handleMinPriceChange = (e) => {
    const value = e?.target?.value?.replace(/\D/g, '');
    setLocalMinPrice(value);
    onPriceChange(value, localMaxPrice);
  };

  const handleMaxPriceChange = (e) => {
    const value = e?.target?.value?.replace(/\D/g, '');
    setLocalMaxPrice(value);
    onPriceChange(localMinPrice, value);
  };

  const handleQuickRangeSelect = (range) => {
    const minValue = range?.min?.toString();
    const maxValue = range?.max ? range?.max?.toString() : '';
    setLocalMinPrice(minValue);
    setLocalMaxPrice(maxValue);
    onPriceChange(minValue, maxValue);
  };

  const formatPrice = (price) => {
    if (!price) return '';
    return new Intl.NumberFormat('fr-CM')?.format(parseInt(price));
  };

  const clearPriceRange = () => {
    setLocalMinPrice('');
    setLocalMaxPrice('');
    onPriceChange('', '');
  };

  return (
    <div className="space-y-4">
      {/* Custom Price Range */}
      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Prix min / Min price"
          type="text"
          placeholder="0"
          value={formatPrice(localMinPrice)}
          onChange={handleMinPriceChange}
          description="FCFA"
        />
        <Input
          label="Prix max / Max price"
          type="text"
          placeholder="Illimité"
          value={formatPrice(localMaxPrice)}
          onChange={handleMaxPriceChange}
          description="FCFA"
        />
      </div>
      {/* Quick Price Ranges */}
      <div className="space-y-2">
        <h4 className="text-sm font-medium text-foreground mb-2">
          Gammes rapides / Quick ranges
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {quickPriceRanges?.map((range, index) => (
            <Button
              key={index}
              variant="outline"
              size="sm"
              onClick={() => handleQuickRangeSelect(range)}
              className="justify-start text-left h-auto py-2 px-3"
            >
              <span className="text-xs">{range?.label}</span>
            </Button>
          ))}
        </div>
      </div>
      {/* Clear Button */}
      {(localMinPrice || localMaxPrice) && (
        <Button
          variant="ghost"
          size="sm"
          onClick={clearPriceRange}
          iconName="X"
          iconPosition="left"
          iconSize={14}
          className="text-muted-foreground hover:text-foreground"
        >
          Effacer / Clear
        </Button>
      )}
      {/* Price Summary */}
      {(localMinPrice || localMaxPrice) && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-primary">
              Gamme sélectionnée / Selected range:
            </span>
            <span className="text-sm font-mono text-foreground">
              {localMinPrice ? `${formatPrice(localMinPrice)} FCFA` : '0 FCFA'} - {' '}
              {localMaxPrice ? `${formatPrice(localMaxPrice)} FCFA` : '∞'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceRangeFilter;